<template>
  <div>
    <elNavbar />
    <header class="header bg-dark">
      <div class="container">
        <div class="col-12 col-md-10 px-4">
          <h1 class="fs-1 mb-4 text-primary">
            Welcome to the NEW ABC APP - a safe space for migrant youth and
            stakeholders to exchange questions, thoughts and information.
          </h1>
          <div class="mb-5">
            <div class="text-white font-size-16 d-inline">
              Join the conversation!
            </div>
            <div class="font-size-16 d-inline ms-3">
              <router-link
                :to="{ name: 'Signup' }"
                custom
                v-slot="{ navigate }"
              >
                <a
                  role="link"
                  @click="navigate"
                  class="btn btn-primary btn-sm"
                  @keypress.enter="navigate"
                >
                  <i class="fa-solid fa-user-plus fa-sm me-1"></i>
                  Sign up for free
                </a>
              </router-link>
            </div>
          </div>
          <div class="font-size-17 text-white">
            NEWABC is a European Commission funded project under the Horizon
            2020 banner for research and innovation under grant agreement
            <span class="fw-bold">No. 101004640</span>
          </div>
        </div>
      </div>
    </header>
    <!-- Start Our  -->
    <section class="bg-light p-3">
      <div class="container">
        <h2 class="h2 text-primary text-center py-5">
          What topic would you like to discuss?
        </h2>
        <div
          v-if="rooms"
          class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4"
        >
          <div v-for="(item, index) in rooms" :key="index" class="col">
            <div class="card partner-wap">
              <div class="card-body">
                <h3 class="card-title text-primary text-capitalize">
                  {{ item.title }}
                </h3>
                <p class="card-text">
                  {{
                    $store.state.utils.filters.stringLimit(
                      item.description,
                      100
                    )
                  }}
                </p>
                <i> {{ item.created_at }}</i>
              </div>
            </div>
          </div>
          <div class="col d-flex align-items-center">
            <div class="card partner-wap col-12">
              <div class="card-body d-flex align-items-center">
                <p class="card-text px-4 text-primary">And more...</p>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center py-4">
          <button class="btn btn-primary">
            <router-link :to="{ name: 'Signup' }" custom v-slot="{ navigate }">
              <span role="link" @click="navigate" @keypress.enter="navigate">
                <i class="fa-solid fa-user-plus fa-sm me-2"></i>Sign up now for
                Free!
              </span>
            </router-link>
          </button>
        </div>
      </div>
    </section>
    <!--End Our -->
    <section class="">
      <img
        :src="$store.state.config.frontpoint + '/storage/youth-group.jpg'"
        class="w-100"
        alt="Youth group"
      />
    </section>

    <elFooter />
  </div>
</template>

<script>
import elFooter from "../../components/Footer.vue";
import elNavbar from "../../components/Navbar.vue";

export default {
  name: "Welcome",

  components: {
    elFooter,
    elNavbar,
  },

  data() {
    return { rooms: undefined };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadRoom();
    });
  },
  methods: {
    loadRoom() {
      // THIS FOR All Rooms
      this.$store.state.modules.api
        .getRooms("created_at", 0, 5)
        .then((resp) => {
          this.rooms = resp.data.units;
          this.$store.state.utils.loaded = true;
        });
    },
  },
};
</script>
